module.exports = __webpack_public_path__ + "img/00034.b650358d.webp";